import './header-image-informational-modal.scss'
import type { CmsImageWithFocalPoint } from '@omnia/ui'
import { RichText } from '@omnia/ui'
import { ImageWithFocalPoint } from '@omnia/ui/src/lib/cms/components/imageWithFocalPoint/ImageWithFocalPoint'
import type { ModalProps } from '@vista-digital/occ-ui'
import { Button, ButtonColor, Modal } from '@vista-digital/occ-ui'
import type { FC } from 'react'

type HeaderImageInformationalModalProps = Pick<ModalProps, 'show' | 'onClose' | 'canBeClosed' | 'className'> & {
    headerImage?: CmsImageWithFocalPoint
    modalContent: string
    closeButtonLabel: string
    modalTitle?: string
}

export const HeaderImageInformationalModal: FC<HeaderImageInformationalModalProps> = ({
    show = false,
    onClose,
    headerImage,
    modalContent,
    closeButtonLabel,
    canBeClosed = true,
    className,
    modalTitle,
}) => {
    return (
        <Modal
            show={show}
            className={`v-modal--header-image-informational${className ? ` ${className}` : ''}`}
            onClose={onClose}
            canBeClosed={canBeClosed}
            footer={
                <Button color={ButtonColor.Primary} onClick={onClose}>
                    {closeButtonLabel}
                </Button>
            }
        >
            {headerImage?.url && (
                <div className="v-modal__header-image">
                    <ImageWithFocalPoint
                        url={headerImage.url}
                        alt={headerImage.alt || ''}
                        fromLeft={headerImage.fromLeft}
                        fromTop={headerImage.fromTop}
                        dimensions={{
                            height: 300,
                            mobile: {
                                height: 200,
                            },
                        }}
                    />
                </div>
            )}

            <div className={`v-modal__content${modalTitle ? ' v-modal__content--with-title' : ''}`}>
                {modalTitle && <h2 className="v-modal__title">{modalTitle}</h2>}
                <RichText htmlText={modalContent} className="v-modal__rich-text" />
            </div>
        </Modal>
    )
}